import { render } from "./print-common.vue?vue&type=template&id=3a390ad0&scoped=true"
import script from "./print-common.vue?vue&type=script&lang=js"
export * from "./print-common.vue?vue&type=script&lang=js"

import "./print-common.vue?vue&type=style&index=0&id=3a390ad0&lang=scss&scoped=true"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a390ad0"]])

export default __exports__